import React, { useEffect, useState } from "react";
import { Container, Col, Row, Card } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { useParams, useLocation, useNavigate, Link } from "react-router-dom";
import SplitNumber from "../../components/SplitNumber";
import ApiBasket from "../../../core/api/api.basket";
import ModalCanclepersonItem from "./Component/ModalCanclepersonItem";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import SkeletonOrderDetail from "../../components/SkeletonComponent/SkeletonOrderDetail";
import CardOrderDetail from "./Component/CardOrderDetail";
import { ToastContainer, toast } from "react-toastify";
import _ from "lodash";
import "react-toastify/dist/ReactToastify.css";
import { IconClipBoard, IconTooman } from "../../../assets/icons";

function OrderDetail() {
  const { id } = useParams();
  let location = useLocation();
  let navigate = useNavigate();
  const [basket, setbasket] = useState({
    basketItems: [],
  });
  const [showModalCancle, setShowModalCancle] = useState(false);
  const [itemForCancleModal, setItemForCancleModal] = useState({});
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isImageLoad, setIsImageLoad] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        let paramId = 0;
        if (id && _.toInteger(id) > 0) paramId = _.toInteger(id);
        if (
          paramId == 0 &&
          !_.isEmpty(location.state) &&
          _.isNumber(location.state?.basketId)
        )
          paramId = _.toInteger(location.state.basketId);
        if (paramId > 0) {
          // دریافت سفارش
          const result = await ApiBasket.getBasketById({ basketId: paramId });

          if (result.succeeded == true) {
            setbasket(result.data, "result result ");
            setIsLoading(false);
          } else {
            // نمایش پیغام
            // toast.configure();
            toast.warn(
              "سفارش مد نظر پیدا نشد لطفا به صفحه سفارشات برگشته و مجددا تلاش نمایید",
              { position: "top-right" }
            );
          }
        }
        // else {
        //     if (!_.isEmpty(location.state) && !_.isEmpty(location?.state?.statusList) && !_.isEmpty(location?.state?.title))
        //     history.push('/orderList', { statusList: location?.state?.statusList, title: location?.state?.title });
        //     else
        //     history.push('/order', { prevPath: location.pathname });
        // }
      } catch (error) {
      } finally {
      }
    })();
    return () => {};
  }, [location, count]);

  const handleModalCancle = (item) => {
    setShowModalCancle(!showModalCancle);
    setItemForCancleModal(item);
  };
  const callBackForModalCancle = () => {
    setShowModalCancle(!showModalCancle);
    setCount((c) => c + 1);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <ToastContainer></ToastContainer> */}
      <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">
        {showModalCancle && (
          <ModalCanclepersonItem
            item={itemForCancleModal}
            basket={basket}
            callBack={callBackForModalCancle}
          />
        )}

        <Container
          fluid
          className={
            !isMobile
              ? "main-content  min-height-page px-0"
              : "main-content px-0"
          }
        >
          {!isMobile ? (
            <Container fluid className="bg-light-3 px-0">
              <Container>
                <Row className="py-3 fs-085">
                  <Col xs={12} className="pe-0">
                    <Link to="/" className="text-muted">
                      {" "}
                      صفحه اصلی{" "}
                    </Link>{" "}
                    /{" "}
                    <Link to="/order" className="text-muted">
                      {" "}
                      سفارش ها{" "}
                    </Link>{" "}
                    /{" "}
                    <Link
                      className="text-muted"
                      to={{
                        pathname: "/order/orderList",
                        state: {
                          statusList: location?.state?.statusList,
                          title: location?.state?.title,
                        },
                      }}
                    >
                      {location?.state?.title}
                    </Link>{" "}
                    <Link
                      className="text-muted"
                      to={{
                        pathname:
                          "/order/orderDetail/" + location?.state?.basketId,
                        state: {
                          statusList: location?.state?.statusList,
                          title: location?.state?.title,
                          basketId: location?.state?.basketId,
                        },
                      }}
                    >
                      {" "}
                      جزئیات سفارش
                    </Link>
                    {/* <Link to="/order/orderList" className="text-muted"> سفارش های در حال پردازش </Link>{" "} / {" "}
                                        <Link to="/order/orderDetail" className="text-muted fw-bold"> جزئیات سفارش </Link> */}
                  </Col>
                </Row>
              </Container>
            </Container>
          ) : (
            <Container fluid className="bg-light-1 pt-3 pb-2 fs-07">
              <Row>
                <Col xs={12} className="my-auto text-right ">
                  <Link to="/" className="text-secondary d-inline-block">
                    صفحه اصلی
                  </Link>
                  <span className="px-1 d-inline-block text-secondary">/</span>

                  <Link to="/order" className="text-secondary  d-inline-block">
                    سفارش های من
                  </Link>
                  <span className="px-1 d-inline-block text-secondary">/</span>
                  <Link
                    className="text-right text-dark"
                    to={{
                      pathname: "/order/orderList",
                      state: {
                        type: location?.state?.type,
                        title: location?.state?.title,
                      },
                    }}
                  >
                    <div className="text-secondary d-inline-block">
                      جزئیات سفارش
                    </div>
                  </Link>
                </Col>
              </Row>
            </Container>
          )}
          <Container fluid="lg" className="  transaction-box fs-08">
            <Row>
              <Col xs={12} lg={5} className="  py-3">
                <Card className="border-0 rounded-3 shadow-sm mt-2 mt-md-0">
                  <Card.Body>
                    <Row className="mb-3">
                      <Col className="small-svg fw-bold fs-085">
                        <IconClipBoard fillColor="#000" /> جزئیات سفارش
                      </Col>
                    </Row>

                    <Row>
                      <Col xs="auto" className="pe-0 text-muted">
                        کد سفارش
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end text-dark ">
                        {isLoading ? (
                          <Skeleton width={50} height={15} />
                        ) : (
                          basket?.id
                        )}
                      </Col>
                    </Row>
                    <Row className="py-1">
                      <Col xs="auto" className="pe-0 text-muted">
                        تاریخ اخرین تغییر
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end text-dark ">
                        {isLoading ? (
                          <Skeleton width={50} height={15} />
                        ) : (
                          basket?.lastModified
                        )}
                      </Col>
                    </Row>
                    <Row className="py-1">
                      <Col xs="auto" className="pe-0 text-muted">
                        تعداد ایتم ها
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end text-dark ">
                        {isLoading ? (
                          <Skeleton width={50} height={15} />
                        ) : !_.isEmpty(basket) &&
                          !_.isEmpty(basket?.basketItems) &&
                          basket?.basketItems.length > 0 ? (
                          basket?.basketItems?.length + " عدد "
                        ) : (
                          "0 عدد"
                        )}
                      </Col>
                    </Row>
                    <Row className="py-1">
                      <Col xs="auto" className="pe-0 text-muted">
                        مبلغ کل{" "}
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end text-dark  ">
                        {isLoading ? (
                          <Skeleton width={50} height={15} />
                        ) : (
                          <span className="medium-svg">
                            <span className="text-decoration-line-throught-rotate border-secondary">
                              {isLoading ? (
                                <Skeleton width={50} height={15} />
                              ) : (
                                <SplitNumber
                                  number={basket?.originalPrice}
                                ></SplitNumber>
                              )}
                            </span>
                            <span>
                              <IconTooman
                                fillColor="#000"
                                style={{ marginTop: "-7px" }}
                              />
                            </span>
                          </span>
                        )}
                      </Col>
                    </Row>
                    <Row className="py-1">
                      <Col xs="auto" className="pe-0 text-muted">
                        تخفیف
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end fw-bold">
                        {isLoading ? (
                          <Skeleton width={50} height={15} />
                        ) : (
                          <span>
                            <SplitNumber
                              number={basket?.originalPrice - basket?.price}
                            ></SplitNumber>
                            <span className="fs-085 medium-svg">
                              <IconTooman
                                fillColor="#000"
                                style={{ marginTop: "-7px" }}
                              />
                            </span>
                          </span>
                        )}{" "}
                      </Col>
                    </Row>
                    <Row className="py-1">
                      <Col xs="auto" className="pe-0 text-muted">
                        مبلغ کل پرداخت شده{" "}
                      </Col>
                      <Col className="my-auto opacity-10">
                        <div
                          style={{
                            borderTop: "1px dashed #000",
                            height: "1px",
                          }}
                        ></div>
                      </Col>
                      <Col xs="auto" className="text-end  text-dark fw-bold">
                        {isLoading ? (
                          <Skeleton width={50} height={15} />
                        ) : (
                          <span className="medium-svg">
                            <SplitNumber number={basket?.price}></SplitNumber>
                            <IconTooman
                              fillColor="#000"
                              style={{ marginTop: "-7px" }}
                            />
                          </span>
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              {isLoading ? (
                <SkeletonOrderDetail />
              ) : (
                <Col xs={12} lg={7} className="  py-3">
                  {/* repeat start */}

                  {basket?.basketItems?.map((item, index) => (
                    <CardOrderDetail
                      item={item}
                      index={index}
                      key={index}
                      basket={basket}
                      callBack={handleModalCancle}
                    />
                  ))}

                  {/* repeat end */}
                </Col>
              )}
            </Row>
          </Container>
        </Container>
      </SkeletonTheme>
    </>
  );
}
export default OrderDetail;
